import { useParams } from "react-router-dom";
import { CompanyLogo } from "../../../assets/Order";
import { useState,useEffect} from "react";
import { toast } from "react-toastify";
import axios from "axios";
import capitalizeFirstLetter from "../../comman/capitalizeFirstLetter";

const Base_Url = process.env.REACT_APP_BASE_URL;
export default function Invoice()
 {
  const { id } = useParams();
  const [order, setOrderData] = useState(null);
  
  useEffect(() => {
      const fetchOrderDetails = async () => {
        if (!id) return;
  
        try {
          const token = localStorage.getItem("token");
          const res = await axios.get(
            `${Base_Url}/api/productOrder/getOrderDetails/${id}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
  
          if (res.data.success) {
            setOrderData(res.data.data);
          } else {
            toast.error(res.data.message || "Failed to fetch order details");
          }
        } catch (err) {
          console.error(err);
          toast.error(err.response?.data?.message || "Failed to fetch order details");
        }
      };
  
      fetchOrderDetails();
  }, [id]);

  if (!order) {
    return (
      <div className="p-4 text-red-600 text-center font-semibold">
        Order not found for ID: {id}
      </div>
    );
  }

    return(
        <section className="px-5 py-1" id="invoice-invoice">
             <div className="grid grid-cols-2 pb-5 border-b-2 border-gray-500">
                <div className="flex flex-col justify-between">
                    <img src={CompanyLogo} alt="invoice preview" className="w-60 h-20"/>
                    <p className="text-4xl font-semibold">Invoice</p>
                </div>
                <div className="flex flex-col space-y-1 justify-start items-end">
                    <p className="text-xl font-medium text-left">Asia Link Computers</p>
                    <p>Shop No.-11, 1577,</p>
                    <p>BhagyaNagari Society,</p>
                    <p>Tilak Road, Sadashiv Peth,</p>
                    <p>Pune - 411030</p>
                    <p>(Near Baba Computer, Opposite Maharashtra Mandal)</p>
                </div>
             </div>

             <div className="grid grid-cols-2 py-5">
                <div className="flex flex-col space-y-1">
                  <p>
                    Person Name : <span>{capitalizeFirstLetter(order.user?.name || "-")}</span>
                  </p>
                  <p>
                    Contact No : {order.user?.mobileNumber || "-"}
                  </p>
                  <p className="">
                    Address :{" "}
                    {order.address
                      ? `${order.address.buildingBlock.toUpperCase()} - ${order.address.flatNo}, ${order.address.buildingName}, ${order.address.landmark || ""}, ${order.address.streetName || ""}, ${order.address.city}, ${order.address.state}, ${order.address.pincode}`
                      : "-"}
                  </p>
                </div>
                <div className="flex flex-col space-y-1">
                </div>
             </div>

              <div className="py-5 border-b-2 border-gray-500">
                <table className="w-full text-left border border-zinc-300 mb-2 rounded">
                    <thead className="bg-gray-100 border-b border-zinc-300">
                    <tr>
                        <th className="p-2 pb-4">Name</th>
                        <th className="p-2 pb-4">Category</th>
                        <th className="p-2 pb-4">Qty</th>
                        <th className="p-2 pb-4">Unit Price</th>
                        <th className="p-2 pb-4">Discount</th>
                        <th className="p-2 pb-4">Total</th>
                    </tr>
                    </thead>
                    <tbody>
                    {order.items.map((item, i) => (
                    <tr key={i} className="border-b border-zinc-300"> 
                        <td className="p-2 pb-4">{item.product?.productName}</td>
                        <td className="p-2 pb-4">{item.product?.category?.name}</td>
                        <td className="p-2 pb-4">{item.quantity}</td>
                        <td className="p-2 pb-4">₹ {Math.round(item.price)}</td>
                        <td className="p-2 pb-4">₹ {Math.round(item.discount)}</td>
                        <td className="p-2 pb-4">₹ {item.quantity * item.price}</td>
                    </tr>
                    ))}
                    </tbody>
                </table>
              </div>

               <div className="py-5 grid grid-cols-2">
                <div></div>

                <div className="grid grid-cols-2 space-y-1 pl-10">
                  <p className="font-medium">Order Total :</p>
                  <p className="text-right">₹ {Math.round(order.subTotal)}</p>
                  <p className="font-medium">Handling Charge:</p>
                  <p className="text-right">+ {Math.round(order.handlingCharges)}</p>
                  <p className="font-medium">TAX/GST:</p>
                  <p className="text-right pb-2">+ {Math.round(order.gstAmount)}</p>
                  <p className="font-medium">Discount:</p>
                  <p className="text-right">- ₹{Math.round(order.discountAmount)}</p>
                  <hr className="col-span-2 border-t-2"/>
                  <p className="font-medium">Payable Amount:</p>
                  <p className="text-right">₹ {Math.round(order.totalAmount)}</p>
                </div>
              </div>
        </section>
    );
}